// libraries and utilities
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse } from "../../interfaces/ErrorResponse";
import { apiPut, BASE_URL, retrieveToken } from "../../store/api";
import { BentukKerjasamaUpdateResponse } from "./types";

import * as bentukKerjasamaActions from "./bentukKerjasama.actions";
import { showModal } from "../modal/modal.actions";

export function* updateBentukKerjasama(
  action: ReturnType<typeof bentukKerjasamaActions.updateBentukKerjasamaAsync.request>
) {
  try {
    const token: string = yield retrieveToken();
    const url = BASE_URL + `bentuk-kerjasama/${action.payload.KERMA_ID}`;
    const result: Response = yield call(apiPut, url, token, action.payload);

    if (result.status === 200) {
      const parsed: BentukKerjasamaUpdateResponse = yield call(result.json.bind(result));
      yield put(showModal('Data berhasil disimpan', 'Silahkan tutup dialog ini untuk melanjutkan kegiatan Anda.'))
      yield put(bentukKerjasamaActions.updateBentukKerjasamaAsync.success(parsed));
      return; 
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      yield put(bentukKerjasamaActions.updateBentukKerjasamaAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      name: 'Internal server error',
      message: 'Internal server error',
      code: 500,
      status: 500
    }
    yield put(bentukKerjasamaActions.updateBentukKerjasamaAsync.failure(parsed));
  }
}

export default function* bentukKerjasamaSagaUpdateBentukKerjasama() {
  yield takeEvery(bentukKerjasamaActions.updateBentukKerjasamaAsync.request, updateBentukKerjasama);
}
